import Brands from '../brand/brand'

/**
 * Retrieves the API endpoint given a brand label and a URL.
 *
 * @param url Endpoint of the API from which to retrieve data. Expects a `BRAND_LABEL` infix by default, such as `https://fa-offers-backend.ddev.site/api/v2/BRAND_LABEL/your-endpoint/`
 * @param brand Label of the brand to insert into the API endpoint string
 * @param brandInfix Infix used to insert the given brand
 * @returns Endpoint with given brand label
 */
export default function getBackendUrlFromBrand(
    url?: string | null,
    brand?: keyof typeof Brands | '' | null,
    // tslint:disable-next-line:typedef
    brandInfix = 'BRAND_LABEL'
): string {
    if (!url || !brand) {
        return ''
    }

    const URL_SEPARATOR = '/'

    // check for `brandInfix` between slashes
    if (!url.split(URL_SEPARATOR).includes(brandInfix)) {
        return url
    }

    if (brand === Brands.VIC) {
        const VIC_BACKEND_LABEL = 'VI'

        return url.replace(brandInfix, VIC_BACKEND_LABEL)
    }

    return url.replace(brandInfix, brand)
}
